import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { CustomToolTipProps } from "./type";
const CustomToolTip = (props: CustomToolTipProps): React.ReactElement => {
  const { triggerChild, triggerContent, side, className } = props;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild onFocusCapture={(e)=>e.stopPropagation()}>{triggerChild}</TooltipTrigger>
        <TooltipContent className={className} side={side}>
          {triggerContent}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CustomToolTip;
